import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CalpadSSIDResoultion } from '../../service/calpad-ssid-resolution';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { ShortDateTime } from 'src/app/pipes/short-date-time';
import { FormControl, FormGroup } from '@angular/forms';

import { resolved } from './model/resolved';
import { ResolvedMatchTaskComponent } from '../resolved-match-task/resolved-match-task.component';
import { SimpleDateTimePipe } from 'src/app/pipes/simple-date-time.pipe';



const today = new Date();
const month = today.getMonth();
const year = today.getFullYear();

@Component({
  selector: 'app-resolved',
  templateUrl: './resolved.component.html',
  styleUrl: './resolved.component.scss'
})
export class ResolvedComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  msg: MsgModel = {};
  isLoading = true;

  displayedColumns = [
    'Action',
    'Name',
    'MSDNumber',
    'InquiryDate',
    'MatchType',
    'ResolvedSSID',
    'ResolvedBy',
    'ResolvedDate'
  ];


  tableDataSource = new MatTableDataSource<resolved>();
  regionCode: string | null = '';
  checked = false;
  fromDate: Date | null = null;
  toDate: Date | null = null;

  maxDate = new Date(); // Today
  constructor(
    private dialog: MatDialog,
    private calpadSSIDResoultion: CalpadSSIDResoultion,
    private route: ActivatedRoute
  ) {
    this.regionCode = this.route.snapshot.paramMap.get('code');


  }

  ngOnInit(): void {
    // Set date range: start date 1 month ago, end date today
    const today = new Date();
    const oneMonthAgo = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
    this.fromDate = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate()); // Set minimum date to one year ago
    this.toDate = today; // Set maximum date to today
    this.loadData();

  }

  ngAfterViewInit(): void {
    this.tableDataSource.paginator = this.paginator;
    this.tableDataSource.sort = this.sort;

  }

  setupSorting(sortState: Sort) {
    this.tableDataSource.sort = this.sort;
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    console.log('Filter Value:', filterValue); // Debugging line
    this.tableDataSource.filter = filterValue;

    if (this.tableDataSource.paginator) {
      this.tableDataSource.paginator.firstPage();
    }
  }
  onCheckedChange() {
    console.log('Checkbox value:', this.checked); // Debugging line
    this.isLoading = true;
    this.loadData();
  }
  private loadData(): void {
    this.msg = new MsgModel();
    this.calpadSSIDResoultion
      .getResolvedCounts(this.regionCode!,
        this.fromDate ? this.formatDate(this.fromDate) : undefined,
        // add one day to toDate so the range is inclusive
        this.toDate ? this.formatDate(new Date(this.toDate.getFullYear(), this.toDate.getMonth(), this.toDate.getDate() + 1)) : undefined,
        //this.toDate ? this.formatDate(this.toDate) : undefined,
        this.checked == true ? "1" : "0")
      .subscribe(res => {
        this.isLoading = false;

        if (res?.students) {
          this.msg.SUCCESS = true;
          const results = JSON.parse((res?.students || []));
          // Recreate datasource with new data so Angular change-detection updates table
          this.tableDataSource = new MatTableDataSource<resolved>(results);
          this.tableDataSource.paginator = this.paginator;
          this.tableDataSource.sort = this.sort;


          this.tableDataSource.data.forEach(item => {
            console.log(item.STUDENT.PERSON); // Debugging line
          });


          this.tableDataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
              case 'Name':
                return [
                  item.STUDENT.PERSON?.LAST_NAME || '',
                  item.STUDENT.PERSON?.SECOND_LAST_NAME || '',
                  item.STUDENT.PERSON?.FIRST_NAME || ''
                ].join(' ').toLowerCase();
              case 'MSDNumber':
                return item.STUDENT.MSD_NUMBER ? item.STUDENT.MSD_NUMBER.toLowerCase() : '';
              case 'InquiryDate':
                return item.CALPADS_STUDENTS_HISTORY.INQUIRY_DATE ? new Date(item.CALPADS_STUDENTS_HISTORY.INQUIRY_DATE).valueOf() : 0;
              case 'MatchType':
                return item.CALPADS_STUDENTS_HISTORY.WINNING_TYPE ? item.CALPADS_STUDENTS_HISTORY.WINNING_TYPE.toLowerCase() : '';
              case 'ResolvedSSID':
                return item.CALPADS_STUDENTS_HISTORY.IDENTIFIER_VALUE ? item.CALPADS_STUDENTS_HISTORY.IDENTIFIER_VALUE.toLowerCase() : '';
              case 'ResolvedBy':
                return item.CALPADS_STUDENTS_HISTORY.RESOLVED_USER ? item.CALPADS_STUDENTS_HISTORY.RESOLVED_USER.toLowerCase() : '';
              case 'ResolvedDate':
                return item.CALPADS_STUDENTS_HISTORY.RESOLVED_DATE ? new Date(item.CALPADS_STUDENTS_HISTORY.RESOLVED_DATE).valueOf() : 0;
              default:
                return (item as any)[property];
            }
          };
          this.tableDataSource.filterPredicate = (item: resolved, filter: string) => {
            const lastName = item.STUDENT.PERSON?.LAST_NAME?.toLowerCase() || '';
            const secondLastName = item.STUDENT.PERSON?.SECOND_LAST_NAME?.toLowerCase() || '';
            const firstName = item.STUDENT.PERSON?.FIRST_NAME?.toLowerCase() || '';
            const middleInitial = item.STUDENT.PERSON?.MIDDLE_INITIAL?.toLowerCase() || '';

            const msdNumber = item.STUDENT.MSD_NUMBER?.toLowerCase() || '';            
            const inquiryDate= item.CALPADS_STUDENTS_HISTORY.INQUIRY_DATE ? new SimpleDateTimePipe().transform(item.CALPADS_STUDENTS_HISTORY.INQUIRY_DATE, 'short')?.toLowerCase() : '';
            const matchType = item.CALPADS_STUDENTS_HISTORY.WINNING_TYPE ? item.CALPADS_STUDENTS_HISTORY.WINNING_TYPE.toLowerCase() : '';
            const resolvedSSID = item.CALPADS_STUDENTS_HISTORY.IDENTIFIER_VALUE ? item.CALPADS_STUDENTS_HISTORY.IDENTIFIER_VALUE.toLowerCase() : '';
            const resolvedBy = item.CALPADS_STUDENTS_HISTORY.RESOLVED_USER ? item.CALPADS_STUDENTS_HISTORY.RESOLVED_USER.toLowerCase() : '';
            const resolvedDate = item.CALPADS_STUDENTS_HISTORY.RESOLVED_DATE ? new ShortDateTime('en-US').transform(item.CALPADS_STUDENTS_HISTORY.RESOLVED_DATE, 'short')?.toLowerCase() : '';            
            const fullName = `${lastName}${secondLastName ? ' ' + secondLastName : ''} ${firstName} ${middleInitial}`.toLowerCase();

            return fullName.includes(filter) ||
              msdNumber.includes(filter) ||
              inquiryDate.includes(filter) ||
              matchType.includes(filter) ||
              resolvedSSID.includes(filter) ||                            
              resolvedBy.includes(filter) ||
              resolvedDate.includes(filter);
          };


        }
        else {
          this.msg.SUCCESS = false;
          this.msg.MSG = 'No Records Found.';
          this.isLoading = false;
        }
      });
  }

  private formatDate(date: Date | undefined): string | undefined {
    if (!date) return undefined;
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  }
  openDialog(row: any) {
    console.log("passing element:", row)
    console.log(row.STUDENT)
    console.log(row.STUDENT.ID)

    const dialogRef = this.dialog.open(ResolvedMatchTaskComponent, {
      width: '90%',
      data: row
    });

    dialogRef.afterClosed().subscribe((result) => {
      // console.log("now resetting resolved match task")
      /// this.contactInfoForm.reset();
      // console.log("result incoming:")
      // console.log(result)
      // console.log("row object will change now")
      // console.log(row)
      /// this.ngOnInit();
      /// this.onRegionChangeEvent.emit(result['REGIONS']);
    });
  }



}
